import React, { Fragment, useState, useEffect } from 'react'
import Banner from '../assets/img/Banner.jpg'
import axios from 'axios'

import {
    Container, Table
} from "reactstrap";

// Import API config object
import { tokenConfig } from '../utils/apiConfig'

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faEdit, faEnvelope, faIdCard, faPhone, faTrash } from '@fortawesome/free-solid-svg-icons';

import Qworky_Banner from '../assets/img/Qworky_Banner.jpg'

// Import components for Profile Page
import UpdatePhoto from '../components/ProfilePage/UpdatePhoto'
import UpdateDetails from '../components/ProfilePage/UpdateDetails';

const ProfilePage = props => {

    const [imageWidth, setImageWidth] = useState(0)
    const [imagePadding, setImagePadding] = useState(0)
    const userDetails = props.userDetails
    const setUserDetails = props.setUserDetails
    const [events, setEvents] = useState([])
    const [registrations, setRegistrations] = useState([])
    const [modal, setModal] = useState(false)
    const [userDetailsModal, setUserDetailsModal] = useState(false)

    const loading = props.loading
    //Getting all Events using axios
    useEffect(() => {
        getRegistrations()
    }, [userDetails])

    //Used to adjust view based on screen size
    useEffect(() => {
        if (window.innerWidth < 500) {
            setImageWidth(window.innerWidth / 5)
            setImagePadding(window.innerWidth / 50)
        } else {
            setImageWidth(100)
            setImagePadding(10)
        }
        function handleResize() {
            if (window.innerWidth < 500) {
                setImageWidth(window.innerWidth / 5)
                setImagePadding(window.innerWidth / 50)
            } else {
                setImageWidth(100)
                setImagePadding(10)
            }
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getRegistrations = async () => {
        if (!userDetails) return null
        await axios.post('/api/registrations/user', userDetails.user, tokenConfig())
            .then(res => {
                setRegistrations(res.data)
            })
            .catch(err => {
                console.log(err)
            })
    }


    const cancelRegistration = async _id => {
        const confirm = window.confirm("Cancel your registration?")
        if (!confirm) return console.log("Cancelled Request")
        await axios.patch(`/api/registrations`, { _id, status: 'Cancelled' }, tokenConfig())
            .then(res => {
                setRegistrations(registrations.filter(registration => registration._id !== _id))
            })
            .catch(err => console.log(err))
    }

    const toggle = () => {
        setModal(!modal)
    }

    const updateProfilePhoto = newPhoto => {
        userDetails.user.photo = newPhoto
    }

    if (loading) {
        return null
    }
    if (!userDetails) {
        return <img
            style={{ width: "100%" }}
            top
            src={Qworky_Banner}
        />
    }


    return (
        <Fragment>
            <UpdateDetails
                userDetails={userDetails}
                modal={userDetailsModal}
                setModal={setUserDetailsModal}
                setUserDetails={setUserDetails}
            />
            <div className='profile-banner'>
                <img
                    style={{ width: "100%" }}
                    src={Banner}
                />
                <div
                    className='img-container'
                    style={{ bottom: `${-imageWidth}px`, height: `${imageWidth * 2}px`, padding: `${imagePadding}px`, cursor: 'pointer' }}
                    onClick={toggle}
                >
                    <img
                        className='round-img'
                        src={userDetails.user.photo}
                    />
                </div>
                <UpdatePhoto modal={modal} toggle={toggle} _id={userDetails.user._id} updateProfilePhoto={updateProfilePhoto} />
            </div>
            <div style={{ marginTop: `${imageWidth + 5}px` }}>
                <center>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '1rem' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '30px', display: 'block' }}>{userDetails.user.name}</span>
                        <span
                            style={{ color: 'blue', fontSize: '20px', marginLeft: '1rem', cursor: 'pointer' }}
                            onClick={() => setUserDetailsModal(!userDetailsModal)}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </span>
                    </div>
                    <span style={{ display: 'block' }}><FontAwesomeIcon icon={faEnvelope} /> {userDetails.user.email}</span>
                    {userDetails.user.phoneNumber && <span style={{ display: 'block' }}><FontAwesomeIcon icon={faPhone} /> {userDetails.user.phoneNumber}</span>}
                    {userDetails.user.validId && <span style={{ display: 'block' }}><FontAwesomeIcon icon={faIdCard} /> {userDetails.user.validId}</span>}
                    {userDetails.user.dob && <span style={{ display: 'block' }}><FontAwesomeIcon icon={faCalendarAlt} /> {new Date(userDetails.user.dob).toLocaleDateString()}</span>}
                </center>
            </div>
            <br />
            <Container>
                <Table className='table'>
                    <thead>
                        <tr>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Registered Email</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Name</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Date</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Start Time</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>End Time</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Difficulty</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Location</th>
                            <th style={{ width: "13.5%" }} className='rowAlign'>Status</th>
                            <th style={{ width: "5.5%" }} className='rowAlign'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {registrations.map(({ _id, event_id, user_id, email, status, sessionId }) => {
                            const event = event_id
                            if (!event || !sessionId || status === 'Cancelled') return null
                            return (
                                <tr key={_id}>
                                    <td className='rowAlign'>{email}</td>
                                    <td className='rowAlign'>{event.name}</td>
                                    <td className='rowAlign'>{sessionId?.date?.substr(0, 10)}</td>
                                    <td className='rowAlign'>{sessionId?.starttime}</td>
                                    <td className='rowAlign'>{sessionId?.endtime}</td>
                                    <td className='rowAlign'>{event.difficulty}</td>
                                    <td className='rowAlign'><a href={event.location} target='_blank'>Click Me</a></td>
                                    <td className='rowAlign'>{status}</td>
                                    <td className='rowAlign'>
                                        <center>
                                            <FontAwesomeIcon
                                                color='red'
                                                className='cursor'
                                                icon={faTrash}
                                                onClick={() => cancelRegistration(_id)}
                                            />
                                        </center>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </Container>
            <br />
        </Fragment>
    )
}

export default ProfilePage